import { createSlice } from '@reduxjs/toolkit';
export const lastWrittenAtSlice = createSlice({
    name: 'lastWrittenAt',
    initialState: {},
    reducers: {
        recordWrite(state, action) {
            state[action.payload] = Date.now();
        },
        clearWrite(state, action) {
            delete state[action.payload];
        },
    },
});
export const { recordWrite, clearWrite } = lastWrittenAtSlice.actions;
